import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useData } from "@/context/DataContext";
import Modal, { Field, inputCls, btnPrimary, btnGhost, btnDanger } from "@/components/Modal";
import { Plus, Pencil, Trash2, Tags } from "lucide-react";

export default function Categories() {
  const { loadMenu } = useData();
  const [cats, setCats] = useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);
  const [name, setName] = useState("");

  const load = async () => {
    const { data } = await api.get("/categories");
    setCats(data);
  };
  useEffect(() => {
    load();
  }, []);

  const openNew = () => {
    setEdit(null);
    setName("");
    setOpen(true);
  };
  const openEdit = (c) => {
    setEdit(c);
    setName(c.name);
    setOpen(true);
  };

  const save = async () => {
    if (!name.trim()) return toast.error("Name required");
    try {
      if (edit) await api.put(`/categories/${edit.id}`, { name, sort_order: edit.sort_order });
      else await api.post("/categories", { name, sort_order: cats.length });
      toast.success("Saved");
      setOpen(false);
      await load();
      await loadMenu();
    } catch (e) {
      toast.error(apiErr(e));
    }
  };

  const del = async (c) => {
    if (!window.confirm(`Delete category "${c.name}"?`)) return;
    try {
      await api.delete(`/categories/${c.id}`);
      toast.success("Deleted");
      await load();
      await loadMenu();
    } catch (e) {
      toast.error(apiErr(e));
    }
  };

  return (
    <div className="p-6 max-w-3xl">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-head text-2xl font-bold">Categories</h1>
          <p className="text-sm text-[#6B7280]">Organise your menu into sections</p>
        </div>
        <button data-testid="add-category-btn" onClick={openNew} className={btnPrimary + " flex items-center gap-2"}>
          <Plus className="w-4 h-4" /> Add Category
        </button>
      </div>

      <div className="bg-[#151D2A] border border-[#23334D] rounded-xl divide-y divide-[#23334D]">
        {cats.length === 0 && <div className="p-8 text-center text-[#6B7280]">No categories yet.</div>}
        {cats.map((c) => (
          <div key={c.id} data-testid={`category-row-${c.id}`} className="flex items-center justify-between px-4 py-3">
            <div className="flex items-center gap-3">
              <Tags className="w-4 h-4 text-[#10B981]" />
              <span className="font-medium">{c.name}</span>
            </div>
            <div className="flex gap-2">
              <button onClick={() => openEdit(c)} className="p-2 text-[#9CA3AF] hover:text-white"><Pencil className="w-4 h-4" /></button>
              <button onClick={() => del(c)} data-testid={`delete-category-${c.id}`} className="p-2 text-[#9CA3AF] hover:text-[#EF4444]"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title={edit ? "Edit Category" : "New Category"}
        footer={
          <>
            <button onClick={() => setOpen(false)} className={btnGhost}>Cancel</button>
            <button onClick={save} data-testid="save-category-btn" className={btnPrimary}>Save</button>
          </>
        }
      >
        <Field label="Category Name">
          <input data-testid="category-name-input" className={inputCls} value={name} onChange={(e) => setName(e.target.value)} autoFocus placeholder="e.g. North Indian" />
        </Field>
      </Modal>
    </div>
  );
}
